import axios from "../../utils/axios";

async function fetch(shopId) {
  const response = await axios.get(`shops/${shopId}`);
  return response;
}

async function update(data) {
  return await axios.patch("shops/own", data);
}

export const shopService = {
  fetch,
  update,
};
